import React, { Component } from 'react';
import { Dialog, DialogActions, DialogContent, FormControl, Grid, InputLabel, MenuItem, Select } from '@material-ui/core';
import AppBarModal from '../../general/AppBarModal';
import BuscarSelect from '../../general/BuscarSelect';
import TareasTerminadas from '../../general/TareasTerminadas';
import emma_w from '../../../global/imagenes/emma_w.png';
import { consulta, obtenerValoresFiltros, obtenerPermisosValorAlt, transformar } from '../../../global/js/funciones';
import { DPTOS_ACADEMICOS, ESTADOS, PROGRAMAS, TIPOS_SOLICITUDES, TIPOS_ACTIVIDADES, CODIGOS_TIPO_POSTULACION } from './helper';
import { BtnForm } from '../../general/BotonesAccion';
import InputBuscar from '../../general/InputBuscar';
import BuscarPersona from '../../general/BuscarPersona';

class SolicitudFiltros extends Component {
  constructor(props) {
    super(props);
    this.state = {
      estados: [],
      periodos: [],
      programas: [],
      tipos: [],
      departamentos: [],
      estado_actual: '',
      tipo: '',
      cargando: true,
      periodo: null,
      programa: null,
      departamento : null,
      tiposActividades: [],
      tipoActividad: null,
      estudiante: {
        id: 0,
        nombre: ''
      },
      buscarEstudiante: false,
    }
  }

  async componentDidUpdate({ modalFiltro }) {
    let { modalFiltro: modalFiltroNew } = this.props;
    if (modalFiltro !== modalFiltroNew) {
      this.setState({ cargando: true });
      let periodos = await this.obtenerPeriodos();
      let tipos = await obtenerValoresFiltros([{ 'llave': 'generica', 'valor': TIPOS_SOLICITUDES }, { 'llave': 'valorb', 'valor': 1 }, { 'llave': 'estado', 'valor': 1 }]);
      let programas = await obtenerValoresFiltros([{ 'llave': 'generica', 'valor': PROGRAMAS }, { 'llave': 'estado', 'valor': 1 }]);
      let departamentos = await obtenerValoresFiltros([{ 'llave': 'generica', 'valor': DPTOS_ACADEMICOS }, { 'llave': 'estado', 'valor': 1 }]);
      // Las postulaciones solo ofrecen los estados que tienen permiso para su tipo.
      let estados = this.esPostulacion()
        ? await this.obtenerEstadosTipo()
        : await obtenerValoresFiltros([{ 'llave': 'generica', 'valor': ESTADOS }, { 'llave': 'estado', 'valor': 1 }]);
      let tiposActividades = await obtenerValoresFiltros([{ 'llave': 'generica', 'valor': TIPOS_ACTIVIDADES }, { 'llave': 'estado', 'valor': 1 }]);
      this.setState({
        'periodos': transformar(periodos, 'periodo', 'periodo'),
        'programas': transformar(programas),
        'departamentos': transformar(departamentos),
        tipos,
        estados,
        tiposActividades,
        cargando: false,
      })
    }
  }

  esPostulacion = () => CODIGOS_TIPO_POSTULACION.indexOf(this.props.tipoSolicitud) >= 0;

  // Los estados por los que pasa el tipo, segun sus Permiso. Vacio si aun no tiene.
  obtenerEstadosTipo = async () => {
    let tipo = await obtenerValoresFiltros([{ 'llave': 'codigo', 'valor': this.props.tipoSolicitud }, { 'llave': 'estado', 'valor': 1 }]);
    if (!tipo || tipo.length === 0) return [];
    let permisos = await obtenerPermisosValorAlt([{ 'llave': 'principal', 'valor': tipo[0].id }, { 'llave': 'secundario__generica', 'valor': ESTADOS }]);
    return (permisos || []).map(({ secundario }) => ({ id: secundario.id, nombre: secundario.nombre }));
  }

  obtenerPeriodos = () => {
    return new Promise(resolve => {
      consulta(`api/v1.0/internacionalizacion/solicitudes/periodos`, null, null,
        (error, estado, resp) => {
          resolve(resp)
        }
      );
    });
  }

  onChange = ({ target }) => {
    let { value, name } = target;
    this.setState({ [name]: value });
  }

  onSubmit = e => {
    let { filtrar, actualizarMensaje, mostrarModalFiltros, tipoSolicitud } = this.props;
    let { tipo, programa, periodo, estado_actual, departamento, estudiante, tipoActividad } = this.state;
    let filtros = [];
    if (tipo !== '') filtros.push({ 'llave': 'tipo_solicitud', 'valor': tipo });
      else filtros.push({ 'llave': 'tipo_solicitud__codigo', 'valor': tipoSolicitud });
    let es_postulacion = this.esPostulacion();
    if (programa !== null && !es_postulacion) filtros.push({ 'llave': 'programa', 'valor': programa.value });
    if (departamento !== null) filtros.push({ 'llave': 'departamento_docente__id', 'valor': departamento.value });
    if (periodo !== null) filtros.push({ 'llave': 'periodo', 'valor': periodo.value });
    if (estado_actual !== '') filtros.push({ 'llave': 'estado_actual', 'valor': estado_actual });
    if (estudiante.id) filtros.push({ 'llave': 'usuario_registro', 'valor': estudiante.id });
    if (tipoActividad !== null && !es_postulacion) filtros.push({ 'llave': 'tipo_actividad', 'valor': tipoActividad });
    if (filtros.length > 0){
      mostrarModalFiltros(false)
      filtrar(filtros);
    } else actualizarMensaje({ titulo: 'Seleccione Algún filtro', tipo: 'info', mostrar: true, tiempo: 6000 });
    e.preventDefault();
  }

  resetState = () => {
    let { limpiar, mostrarModalFiltros } = this.props;
    this.setState({
      periodo: null,
      programa: null,
      tipo: '',
      estado_actual: '',
      departamento: null,
      tipoActividad: null,
    })
    limpiar();
    mostrarModalFiltros(false);
  }

  render () {
    let { modalFiltro, mostrarModalFiltros, tipoSolicitud } = this.props;
    let { cargando, periodos, periodo, programas, programa, tipos, tipo, estados, estado_actual, departamento, departamentos, tiposActividades, tipoActividad, estudiante, buscarEstudiante } = this.state;
    return (
      <>
        <Dialog
          fullWidth={true}
          maxWidth="sm"
          open={modalFiltro}
          onClose={() => mostrarModalFiltros(false)}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <AppBarModal
            titulo="¡ Aplicar Filtros !"
            mostrarModal={() => mostrarModalFiltros(false)}
            titulo_accion="Limpiar"
            accion={this.resetState}
          />
          <DialogContent className="scroll" style={{ overflow: "visible" }}>
            {!cargando ? (
              <Grid container spacing={3} className="margin_cont">
                <Grid item xs={12} xl={12} sm={12} md={12} lg={12}>
                  <InputBuscar
                    id="estudiante"
                    label="Persona"
                    placeholder="Clic aquí para buscar"
                    value={estudiante.nombre}
                    callback={() => this.setState({ buscarEstudiante: true })}
                  />
                </Grid>
                <Grid item xs={12} xl={12} sm={12} md={12} lg={12}>
                  <BuscarSelect
                    datos={periodos}
                    cambiarEstado={(value) => this.setState({ periodo: value })}
                    valor={periodo}
                    id="select-periodo"
                    nombre="Período"
                    placeholder="Seleccione Período"
                  />
                </Grid>
                {/* <Grid item xs = { 12 } xl = { 12 } sm = { 12 } md = { 12 } lg = { 12 }>
                  <FormControl className = 'form-control'>
                    <InputLabel htmlFor = "tipo">Seleccione Tipo de Solicitud</InputLabel>
                    <Select
                      inputProps = { {
                        name: 'tipo',
                        id: 'tipo',
                      } }
                      value = { tipo }
                      onChange = { this.onChange }>
                      {
                        tipos.map(({ id, nombre }) => <MenuItem key = { id } value = { id }>{ nombre }</MenuItem>)
                      }
                    </Select>
                  </FormControl>
                </Grid> */}
                {tipoSolicitud && tipoSolicitud == "Reg_Mov_Int" ? (
                  <Grid item xs={12} xl={12} sm={12} md={12} lg={12}>
                    <BuscarSelect
                      datos={departamentos}
                      cambiarEstado={(value) =>
                        this.setState({ departamento: value })
                      }
                      valor={departamento}
                      id="select-departamento"
                      nombre="Departamento"
                      placeholder="Seleccione Departamento"
                    />
                  </Grid>
                ) : !this.esPostulacion() && (
                  <Grid item xs={12} xl={12} sm={12} md={12} lg={12}>
                    <BuscarSelect
                      datos={programas}
                      cambiarEstado={(value) =>
                        this.setState({ programa: value })
                      }
                      valor={programa}
                      id="select-programa"
                      nombre="Programa"
                      placeholder="Seleccione Programa"
                    />
                  </Grid>
                )}
                {
                  // Tipo de actividad es de los registros: las postulaciones no lo tienen.
                  !this.esPostulacion() &&
                <Grid item xs={12} xl={12} sm={12} md={12} lg={12}>
                  <FormControl className="form-control">
                    <InputLabel htmlFor="tipoActividad">
                      Seleccione Tipo Actividad
                    </InputLabel>
                    <Select
                      inputProps={{
                        name: "tipoActividad",
                        id: "tipoActividad",
                      }}
                      value={tipoActividad}
                      onChange={this.onChange}
                    >
                      {tiposActividades.map(({ id, nombre }) => (
                        <MenuItem key={id} value={id}>
                          {nombre}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
                }
                {/* Comentado por ser redudante al filtrar por estado en registros de movilidad */}
                <Grid item xs={12} xl={12} sm={12} md={12} lg={12}>
                  <FormControl className="form-control">
                    <InputLabel htmlFor="estado_actual">
                      Seleccione Estado
                    </InputLabel>
                    <Select
                      inputProps={{
                        name: "estado_actual",
                        id: "estado_actual",
                      }}
                      value={estado_actual}
                      onChange={this.onChange}
                    >
                      {estados.map(({ id, nombre }) => (
                        <MenuItem key={id} value={id}>
                          {nombre}
                        </MenuItem>
                      ))}
                      {
                        estados.length === 0 &&
                        <MenuItem value="" disabled>
                          Este tipo de solicitud aún no tiene estados con permiso
                        </MenuItem>
                      }
                    </Select>
                  </FormControl>
                </Grid>
              </Grid>
            ) : (
              <TareasTerminadas
                mensaje="Cargando.."
                marginTop="7%"
                imagen={emma_w}
                widthImg="7%"
              />
            )}
          </DialogContent>
          <DialogActions>
            <BtnForm
              texto="CANCELAR"
              callback={() => mostrarModalFiltros(false)}
            />
            {!cargando && <BtnForm texto="FILTRAR" callback={this.onSubmit} />}
          </DialogActions>
        </Dialog>

        <Dialog
          fullWidth={true}
          maxWidth="sm"
          fullScreen={window.innerWidth < 600}
          open={buscarEstudiante}
          onClose={() => this.setState({ buscarEstudiante: false })}
        >
          <AppBarModal
            titulo={"¡ Buscar Persona !"}
            mostrarModal={() => this.setState({ buscarEstudiante: false })}
            titulo_accion="CERRAR"
            accion={() => this.setState({ buscarEstudiante: false })}
          />
          <DialogContent style={{ padding: "0" }} className="scroll">
            <BuscarPersona
              callback={({
                id,
                primer_nombre,
                primer_apellido,
                segundo_apellido,
              }) =>
                this.setState({
                  estudiante: {
                    id,
                    nombre: `${primer_nombre} ${primer_apellido} ${segundo_apellido}`,
                  },
                  buscarEstudiante: false,
                })
              }
            />
          </DialogContent>
          <DialogActions>
            <BtnForm
              texto="CANCELAR"
              callback={() => this.setState({ buscarEstudiante: false })}
            />
          </DialogActions>
        </Dialog>
      </>
    );
  }
}

export default SolicitudFiltros;
